module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/apple_de.svg", __webpack_public_path__ + "_/_/_/common/components/mobile/images/apple_de.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/apple_de.svg
// module id = 603
// module chunks = 2